import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import { createStructuredSelector } from "reselect";
// import CheckboxCustom from "../../components/checkboxCustom/checkboxCustom.component";
import { RadioBtnsStyled } from "./radioBtns.styles";
import BimehImg from "../../assets/img/malat-bime.png";
import { setShownSupport } from "../../redux/preReq/preReq.actions";
import { selectShownSupport } from "../../redux/preReq/preReq.selectors";
import {
  setBimeh,
  setBarnameh,
  setLoadValue,
} from "../../redux/newRequest/newRequest.actions";
import {
  selectNewRequestBimeh,
  selectNewRequestBarnameh,
  selectNewRequestLoadValue,
  selectNewRequest,
} from "../../redux/newRequest/newRequest.selectors";
import {
  toPersianNum,
  toSeperatedNum,
  toPureNum,
  toEnglishNum,
} from "../../assets/utils";
import { Animated } from "react-animated-css";
import socket from "../../assets/socketConnection";
import { selectPreReqTypeOfLoad } from "../../redux/preReq/preReq.selectors";

const RadioBtns = ({
  dark,
  bimehOnly,

  setBimeh,
  selectNewRequestBimeh,
  setBarnameh,
  selectNewRequestBarnameh,
  setLoadValue,
  selectNewRequestLoadValue,
  selectShownSupport,
  setShownSupport,
  selectNewRequest,
}) => {
  const typeOfLoad = useSelector(selectPreReqTypeOfLoad);

  const [payAble, setPayAble] = useState({
    charj: 0,
    description: "",
  });

  const handle_price_change = (e) => {
    const value = toPureNum(e.currentTarget.value);
    const EngValue = toEnglishNum(value);
    setLoadValue(EngValue);

    const {
      source_location,
      destination_location,
      selected_vehicle,
      suggestionPrice,
      load_value,
    } = selectNewRequest;

    const obj = {
      source_location,
      destination_location,
      suggested_price: suggestionPrice,
      value: EngValue,
      vehicle_requested: selected_vehicle,
    };
    console.log(obj.value, "yyy");

    if (obj.value.length >= 6) {
      socket.emit("get_request_insurance_offers", obj);
      socket.on("response_request_offers", (data) => {
        console.log(data, "xxxxxxxxxxxxx");
        setShownSupport(data);
        setPayAble({
          description: data.insurance.description,
          charj: Number(data.insurance.charj).toFixed(),
        });
      });
    } else {
      setPayAble({
        description: "",
        charj: 0,
      });
    }
    // e.currentTarget.value = toSeperatedNum(toPersianNum(value));

    // debugger;
  };

  return (
    <RadioBtnsStyled dark>
      <div
        className={`${
          bimehOnly && "d-flex align-items-center flex-row-reverse"
        }`}
      >
        <div className="d-flex align-items-center justify-content-between w-100">
          {/* {!bimehOnly && (
            <div className="d-flex align-items-center ">
              <label
                htmlFor="bimeh"
                className="font-weight-bold"
                style={{ width: "55px" }}
              >
                بیمه‌نامه
              </label>
              <CheckboxCustom
                dark
                setTheState={setBimeh}
                selectTheState={selectNewRequestBimeh}
              />
            </div>
          )} */}
          {/* {selectNewRequestBimeh || selectNewRequestBarnameh ? (
          <div className="position-relative">
            <input
              onChange={(e) => handle_price_change(e)}
              className="input-price"
              type="text"
              name=""
              id=""
              placeholder="ارزش بار"
              inputmode="tel"
              value={toSeperatedNum(toPersianNum(selectNewRequestLoadValue))}
              maxLength="14"
            />
            <div className="price-toman">تومان</div>
          </div>
        ) : null} */}

          <Animated
            animationIn="bounceInDown"
            animationOut="bounceOutUp"
            animationInDuration={500}
            animationOutDuration={500}
            isVisible={selectNewRequestBimeh || selectNewRequestBarnameh}
            className="animated w-100"
          >
            <div className="position-relative">
              <input
                onChange={(e) => handle_price_change(e)}
                className="input-price"
                type="text"
                name=""
                id=""
                placeholder="ارزش بار"
                inputMode="tel"
                value={toSeperatedNum(toPersianNum(selectNewRequestLoadValue))}
                maxLength="14"
              />
              <div className="price-toman">تومان</div>
            </div>
          </Animated>
        </div>
        <div className="small">حداقل ارزش بار ۱۰۰ هزار تومان</div>
        {/* <div>
          <div className="d-flex align-items-center ">
            <label
              htmlFor="bimeh"
              className=" font-weight-bold"
              style={{ width: "55px" }}
            >
              بارنامه
            </label>
            <CheckboxCustom
              dark
              setTheState={setBarnameh}
              selectTheState={selectNewRequestBarnameh}
            />
          </div>
        </div> */}
      </div>
      {payAble.description && (
        <div className="d-flex align-items-center">
          <div className="mt-1 text-muted text-justify ml-2">
            {toPersianNum(payAble.description)}
          </div>
          <div>
            <img src={BimehImg} alt="" className="bimeh-img" />
          </div>
        </div>
      )}
      {typeOfLoad.type === "instant" && (
        <div className="pay-price mt-2">
          <span>قابل پرداخت: </span>
          <span>
            {toSeperatedNum(
              toPersianNum(
                Number(selectNewRequest.shownSuggestionPrice) +
                  Number(payAble.charj)
              )
            )}
          </span>
          <span> تومان </span>
        </div>
      )}
    </RadioBtnsStyled>
  );
};

const mapStateToProps = createStructuredSelector({
  selectNewRequestBimeh: selectNewRequestBimeh,
  selectNewRequestBarnameh: selectNewRequestBarnameh,
  selectNewRequestLoadValue: selectNewRequestLoadValue,
  selectShownSupport: selectShownSupport,

  selectNewRequest: selectNewRequest,
});

const mapDispatchToProps = (dispatch) => ({
  setBimeh: (x) => dispatch(setBimeh(x)),
  setBarnameh: (x) => dispatch(setBarnameh(x)),
  setLoadValue: (x) => dispatch(setLoadValue(x)),
  setShownSupport: (x) => dispatch(setShownSupport(x)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RadioBtns);
